class MinerwaFaq extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('[data-faq-trigger]')];
    this.triggers.forEach((trigger) => {
      const panel = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
      if (!panel) return;
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }
}

if (!customElements.get('minerwa-faq')) {
  customElements.define('minerwa-faq', MinerwaFaq);
}
